/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request body for linking a Curai Classic account to the signed-in CHAI user.
 */
export interface LinkClassicAccountRequest {
  /** Short-lived code proving ownership of the user's Curai Classic account */
  code: string;
}
